import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useLibraryUIContext } from "./LibraryUIContext";
import { LibraryFilter } from "./library-table/library-filter/LibraryFilter";
import { RoleChecker } from "../../../../RoleChecker";
import LibraryCreate from "./library-create/LibraryCreate";
import {
  createLibraryFile,
  createLibraryFolder,
  deleteLibraryFile,
  deleteLibraryFolder,
  fetchFiles,
  fetchLibrarys,
  updateLibraryFolder
} from "../../_redux/library/libraryAction";
import { createNotification } from "../../_redux/notification/notificationAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import LibraryTablePagination from "./library-table/LibraryTablePagination";
import LibraryTable from "./library-table/LibraryTable";
import LibraryUploadFile from "./library-upload-file/LibraryUploadFile";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import { ConfirmationModal } from "../../../Donation/pages/confirmation/confirmation-edit/confirmation-edit-form/ConfirmationModal";
import LibraryGrid from "./library-grid/LibraryGrid";
import moment from "moment";

export const LibraryCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState({
    createFolder: false,
    uploadFile: false,
    deleteModal: false
  });
  const [currentItem, setCurrentItem] = useState({});

  // * Library UI Context
  const libraryUIContext = useLibraryUIContext();
  const libraryUIProps = useMemo(() => {
    return {
      queryParams: libraryUIContext.queryParams,
      setQueryParams: libraryUIContext.setQueryParams,
      openEditLibraryPage: libraryUIContext.openEditLibraryPage,
      openLibraryFilePage: libraryUIContext.openLibraryFilePage
    };
  }, [libraryUIContext]);

  // * Getting curret state of library list from store (Redux)
  const {
    totalCount,
    entities,
    listLoading,
    actionsLoading,
    libraryFiles
  } = useSelector(state => state.superAdminLibrary, shallowEqual);

  useEffect(() => {
    // * Requset ke Library Action
    if (id) {
      dispatch(
        fetchLibrarys({
          filter: { ...libraryUIProps.queryParams.filter },
          parent_uuid: id
        })
      );
      dispatch(fetchFiles({ library_folder_uuid: id }));
    } else {
      dispatch(fetchLibrarys(libraryUIProps.queryParams));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [libraryUIProps.queryParams, dispatch]);

  // * CREATE FOLDER
  const onSubmitCreateFolder = values => {
    if (!values.uuid) {

      // [AY] #108 disable notification
      // if (values.check_sharing) {

      //   // Expired Data selama 7 hari
      //   const currentDate = moment();
      //   const newDate = currentDate.add(7, 'days'); // setting waktu selama 7 hari
        
      //   const dataNotification = {
      //     is_all_organization: true, 
      //     type: 'INFO', 
      //     expired_date: newDate.format('YYYY-MM-DD HH:mm:ss'), 
      //     message: values.description,
      //   }

      //   dispatch(
      //     createNotification({ ...dataNotification })
      //   )
      // }

      dispatch(
        createLibraryFolder({
          ...values,
          parent_uuid: id
        })
      )
        .then(res => {
          toast.success(res.data.message, toastOption);
          if (id) {
            dispatch(
              fetchLibrarys({
                filter: { ...libraryUIProps.queryParams.filter },
                parent_uuid: id
              })
            );
            dispatch(fetchFiles({ library_folder_uuid: id }));
          } else {
            dispatch(fetchLibrarys(libraryUIProps.queryParams));
          }
          setOpenModal(prev => ({ ...prev, createFolder: false }));
          setCurrentItem({});
        })
        .catch(err => {
          toast.error(err.message);
        });
    } else {
      dispatch(
        updateLibraryFolder({
          ...values
        })
      )
        .then(res => {
          toast.success(res.data.message, toastOption);
          if (id) {
            dispatch(
              fetchLibrarys({
                filter: { ...libraryUIProps.queryParams.filter },
                parent_uuid: id
              })
            );
            dispatch(fetchFiles({ library_folder_uuid: id }));
          } else {
            dispatch(fetchLibrarys(libraryUIProps.queryParams));
          }
          setOpenModal(prev => ({ ...prev, createFolder: false }));
          setCurrentItem({});
        })
        .catch(err => {
          toast.error(err.message);
        });
    }
  };

  // * UPLOAD FILE
  const onSubmitCreateFile = value => {
    const formData = new FormData();
    formData.append("name", value.name);
    formData.append("file", value.file);
    formData.append("library_folder_uuid", id);
    dispatch(createLibraryFile(formData))
      .then(res => {
        toast.success(res.data.message, toastOption);
        if (id) {
          dispatch(
            fetchLibrarys({
              filter: { ...libraryUIProps.queryParams.filter },
              parent_uuid: id
            })
          );
          dispatch(fetchFiles({ library_folder_uuid: id }));
        } else {
          dispatch(fetchLibrarys(libraryUIProps.queryParams));
        }
        setOpenModal(prev => ({ ...prev, uploadFile: false }));
        setCurrentItem({});
      })
      .catch(err => {
        toast.error(err.message);
      });
  };

  // * DELETE FOLDER / FILE
  const onDelete = () => {
    if (currentItem.filename) {
      dispatch(deleteLibraryFile(currentItem.uuid))
        .then(res => {
          toast.success(res.data.message, toastOption);
          if (id) {
            dispatch(
              fetchLibrarys({
                filter: { ...libraryUIProps.queryParams.filter },
                parent_uuid: id
              })
            );
            dispatch(fetchFiles({ library_folder_uuid: id }));
          } else {
            dispatch(fetchLibrarys(libraryUIProps.queryParams));
          }
          setOpenModal(prev => ({ ...prev, deleteModal: false }));
          setCurrentItem({});
        })
        .catch(err => {
          toast.error(err.message);
        });
    } else {
      dispatch(deleteLibraryFolder(currentItem.uuid))
        .then(res => {
          if (res.status == 404) {
            toast.error(res.data.message, toastOption);
          } else {
            toast.success(res.data.message, toastOption);
            if (id) {
              dispatch(
                fetchLibrarys({
                  filter: { ...libraryUIProps.queryParams.filter },
                  parent_uuid: id
                })
              );
              dispatch(fetchFiles({ library_folder_uuid: id }));
            } else {
              dispatch(fetchLibrarys(libraryUIProps.queryParams));
            }
            setOpenModal(prev => ({ ...prev, deleteModal: false }));
            setCurrentItem({});
          }
        })
        .catch(err => {
          toast.error(err.message);
        });
    }
  };

  const allowCreate = RoleChecker("Create", "library");
  const allowEdit = RoleChecker("Edit", "library");
  const allowDelete = RoleChecker("Delete", "library");

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      {/* CREATE FOLDER MODAL */}
      <LibraryCreate
        show={openModal.createFolder}
        onHide={() => {
          setOpenModal(prev => ({ ...prev, createFolder: false }));
          setCurrentItem({});
        }}
        onSubmit={onSubmitCreateFolder}
        defaultValues={currentItem}
      />
      {/* UPLOAD FILE MODAL */}
      <LibraryUploadFile
        show={openModal.uploadFile}
        onHide={() => {
          setOpenModal(prev => ({ ...prev, uploadFile: false }));
          setCurrentItem({});
        }}
        onSubmit={onSubmitCreateFile}
        defaultValues={currentItem}
      />
      {/* UPLOAD FILE MODAL */}
      <ConfirmationModal
        show={openModal.deleteModal}
        onHide={() => setOpenModal(prev => ({ ...prev, deleteModal: false }))}
        modalTitle={`Hapus ${currentItem.filename ? "File" : "Folder"}`}
        modalTitleContent={`Apakah anda yakin ingin menghapus ${currentItem.name ??
          currentItem.filename}`}
        onClick={onDelete}
      />
      <Card>
        <CardHeader title="Library">
          <CardHeaderToolbar>
            {allowCreate && (
              <>
                {id && (
                  <button
                    type="button"
                    className="btn mx-1 btn-outline-primary"
                    onClick={() =>
                      setOpenModal(prev => ({ ...prev, uploadFile: true }))
                    }
                  >
                    Upload File
                  </button>
                )}
                <button
                  type="button"
                  className="btn mx-1 btn-primary"
                  onClick={() =>
                    setOpenModal(prev => ({ ...prev, createFolder: true }))
                  }
                >
                  Tambah Folder
                </button>
              </>
            )}
            {id && (
              <button
                type="button"
                className="btn mx-1 btn-secondary"
                onClick={() => history.goBack()}
              >
                Kembali
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <LibraryGrid
            id={id}
            folders={entities}
            files={libraryFiles}
            openEditLibraryPage={libraryUIProps.openEditLibraryPage}
            setCurrentItem={setCurrentItem}
            setOpenModal={setOpenModal}
            allowCreate={allowCreate}
            allowEdit={allowEdit}
            allowDelete={allowDelete}
          />
          {/* <LibraryFilter />
          {!id ? (
            // ? LIBRARY TABLE PAGINATION FOR FOLDER WITHOUT PARENT UUID
            <>
              <LibraryTablePagination
                totalCount={totalCount}
                listLoading={listLoading}
                entities={entities}
                queryParams={libraryUIProps.queryParams}
                setQueryParams={libraryUIProps.setQueryParams}
                openEditLibraryPage={libraryUIProps.openEditLibraryPage}
                setCurrentItem={setCurrentItem}
                setOpenModal={setOpenModal}
              />
            </>
          ) : (
            // ? LIBRARY TABLE FOR FOLDER WITH PARENT UUID
            <LibraryTable
              entities={[...entities, ...libraryFiles] ?? []}
              setCurrentItem={setCurrentItem}
              setOpenModal={setOpenModal}
              openEditLibraryPage={libraryUIProps.openEditLibraryPage}
            />
          )} */}
        </CardBody>
      </Card>
    </>
  );
};
